import { Component, OnInit, Input } from '@angular/core';
import { Student } from '../shared/student.model';
import { Program } from '../../programs/shared/program.model';

@Component({
  selector: 'app-student',
  templateUrl: './student.component.html',
  styleUrls: ['./student.component.scss']
})
export class StudentComponent implements OnInit {

  @Input() student: Student;
  @Input() program: Program;
  dateCurrent: Date;

  constructor() {

  }

  ngOnInit() {
    this.dateCurrent = new Date();
  }


}
